import React, { Component, useEffect, useState } from "react";
import { Select } from "antd";
import {IAttrComponent} from "../Attribute";
export interface ISelectAttrData extends IAttrComponent {
    attrValue: {
        defaultValue?: string | number
    };
    options: { value: string | number, label: string }[],
    onChange: (value: { value: string | number }) => void,
    setRefresh(func: Function): void;
}

/**
 * 下拉框
 */
export function SelectAttr(data: ISelectAttrData) {
    let [v, setValue] = useState(data.attrValue.defaultValue);
    useEffect(() => {
        data.setRefresh((val) => {
            setValue(val);
        });
        setValue(data.attrValue.defaultValue);
    }, [data])
    return (
        <Select disabled={data.disable} size="small" onChange={(val) => {
            data.onChange({ value: val});
            setValue(val);
        }} value={v} >
            {
                data.options.map((item, index) => {
                    return <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
                })
            }
        </Select>
    )
}